import React from 'react';
import 'loaders.css/loaders.css';

export const SpinnerLoaderModal = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: '100%' }} // Use parent's height instead of full viewport
    >
      <div className="spinner-border spinner-border-lg text-primary" role="status" />
    </div>
  );
};
